"use client"

import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import { JobStatusTagStatus, JobStatusTag } from "@/components/JobStatusTag"
import { JobPostingStatus } from "@/gql/graphql"

const JobDetailsFooterClosedBannerFragment = graphql(`
  fragment JobDetailsFooterClosedBanner on JobPosting {
    __typename
    id
    status
  }
`)

interface Props {
  jobPosting: FragmentType<typeof JobDetailsFooterClosedBannerFragment> | undefined | null
}

export const JobDetailsFooterClosedBanner: FC<Props> = props => {
  const jobPosting = useFragment(JobDetailsFooterClosedBannerFragment, props.jobPosting)

  const jobClosed = jobPosting?.status === JobPostingStatus.Closed

  if (!jobClosed) {
    return null
  }

  return (
    <div className="flex w-full flex-row items-center">
      <JobStatusTag showStatusPrefix={false} status={JobStatusTagStatus.Closed} />
    </div>
  )
}
